// extracted by mini-css-extract-plugin
module.exports = {"svg":"GraphComponent_svg__3E0n3","node":"GraphComponent_node__3vES5","edgePath":"GraphComponent_edgePath__22qep","edgeRef":"GraphComponent_edgeRef__30Ojg"};